import 'react-toastify/dist/ReactToastify.css';
import * as Yup from 'yup';
import AdminTable from './Admintable';
import Breadcrumb from '../../components/Common/Breadcrumb';
import React, { useEffect, useState } from 'react';
import Select from 'react-select';
import avatar from '../../assets/images/users/empty.jpg';
import axios from 'axios';
import withRouter from '../../components/Common/withRouter';
import { useFormik } from 'formik';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { ToastContainer, toast } from 'react-toastify';
import { createSelector } from 'reselect';
import { editProfile, resetProfileFlag } from '../../store/actions';
import { FaEye, FaEyeSlash } from "react-icons/fa";
import {
  Container,
  Row,
  Col,
  Card,
  Alert,
  CardBody,
  FormFeedback,
  Modal,
  ModalHeader,
  ModalBody,
  Form,
  FormGroup,
  Label,
  Input,
  Button,
  ModalFooter,
} from 'reactstrap';
// Formik Validation
//redux

//Import Breadcrumb

// actions

const UserProfile = () => {
  document.title = 'Profile | Linc Quality Hub';

  const dispatch = useDispatch();

  const [name, setname] = useState('');
  const [idx, setidx] = useState(1);

  const userprofilepage = createSelector(
    (state) => state.profile,
    (state) => ({
      error: state.error,
      success: state.success,
    }),
  );
  // Inside your component
  const { error, success } = useSelector(userprofilepage);

  useEffect(() => {
    const storeNames = localStorage.getItem('name');
    const storedUsername = localStorage.getItem('username');

    if (storeNames && storeNames) {
      setname(storeNames);
      setemail(storedUsername);
    }
  });
  const user_token = localStorage.getItem('usertoken');
  const userRole = localStorage.getItem('userpremission');

  const validation = useFormik({
    // enableReinitialize : use this flag when initial values needs to be changed
    enableReinitialize: true,

    initialValues: {
      username: name || '',
      idx: idx || '',
    },
    validationSchema: Yup.object({
      username: Yup.string().required('Please Enter Your UserName'),
    }),
    onSubmit: (values) => {
      dispatch(editProfile(values));
    },
  });

  const [modalOpen, setmodalOpen] = useState(false);
  const toggleModal = () => {
    setmodalOpen(!modalOpen);
    setValidationErrors({});
    setSelectedPrograms(new Set());
    setPrograms([]); // This clears ProgramOptions
    setSelectedunits(new Set());
    setUnits([]); // Also clear unit dropdown list
  };

  const [modalOpenEdit, setmodalOpenEdit] = useState(false);
  const toggleModalEdit = () => setmodalOpenEdit(!modalOpenEdit);

  const [userData, setuserData] = useState([]);
  const [selectedUser, setSelectedUser] = useState(null); // <-- Add this
  const [universities, setUniversities] = useState([]);
  const [selectedUniversities, setSelectedUniversities] = useState([]);
  const [programs, setPrograms] = useState([]);
  const [selectedPrograms, setSelectedPrograms] = useState(new Set());
  const [units, setUnits] = useState([]);
  const [selectedunits, setSelectedunits] = useState(new Set());
  const [userDataTable, setuserTableData] = useState(null);
  const [role, setRole] = useState('');
  const [selectedTabs, setSelectedTabs] = useState(new Set());
  const [firstName, setFirstName] = useState('');
  const [lastName, setLastName] = useState('');
  const [email, setemail] = useState('');
  // console.log("email",email)
  const [emailform, setEmaliform] = useState('');
  const [validationErrors, setValidationErrors] = useState({});
  const [modalOpenChangePassword, setModalOpenChangePassword] = useState(false);
  const [currentPassword, setCurrentPassword] = useState('');
  const [newPassword, setNewPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  const [formErrors, setFormErrors] = useState({});
  const [showCurrent, setShowCurrent] = useState(false);
  const [showNew, setShowNew] = useState(false);
  const [showConfirm, setShowConfirm] = useState(false);
  const navigate = useNavigate();
  const tabOptions = [
    { value: 1, label: 'Overview' },
    { value: 2, label: 'Unit Overview' },
    { value: 3, label: 'Unit Details' },
    { value: 4, label: 'Staff Overview' },
    { value: 5, label: 'Staff Details' },
  ];

  useEffect(() => {
    setSelectedPrograms(new Set());
    setPrograms([]); // This clears ProgramOptions
    setSelectedunits(new Set());
    setUnits([]); // Also clear unit dropdown list
  }, [selectedUniversities]);

  useEffect(() => {
    setSelectedunits(new Set());
    setUnits([]); // Also clear unit dropdown list
  }, [selectedPrograms]);

  // Convert your universities into label/value format
  const universityOptions = universities.map((uni) => ({
    value: uni.id,
    label: uni.short_name,
  }));

  // const ProgramOptions = programs.map((pro) => ({
  //   value: pro.id,
  //   label: pro.name
  // }));
  // const unitsOptions = units.map((units) => ({
  //   value: units.id,
  //   label: units.name
  // }));
  const programOptions =
    programs.length > 0
      ? [
        { label: 'All', value: 'all' },
        ...programs.map((p) => ({ label: p.name, value: p.id })),
      ]
      : [];

  const unitOptions =
    units.length > 0
      ? [
        { label: 'All', value: 'all' },
        ...units.map((u) => ({ label: u.name, value: u.id })),
      ]
      : [];

  //handle submit
  const handleSubmit = async (e) => {
    e.preventDefault(); // Always prevent default first
    const errors = {};

    if (!selectedUser?.username?.trim()) {
      errors.username = 'Username / Email is required.';
    }
    if (!selectedUser?.username?.trim()) {
      errors.username = 'Username / Email is required';
    }
    if (!role || role === 'selectrole') {
      errors.role = 'Role is required.';
    }

    if (Object.keys(errors).length > 0) {
      setValidationErrors(errors);
      return;
    }

    // If no errors
    setValidationErrors({});
    // Proceed with your save logic
    // ...
    e.preventDefault();

    const newUserData = {
      user_id: selectedUser?.id || 'null',
      // first_name: selectedUser?.first_name || '',
      // last_name: selectedUser?.last_name || '',
      first_name: firstName || '',
      last_name: lastName || '',
      contact_number: document.getElementById('contact')?.value || '',
      email: selectedUser?.username || 'null',
      designation: 'null', // if you add a field later
      role: role,
      universities: selectedUniversities?.length ? selectedUniversities : null,
      programs: selectedPrograms?.size ? Array.from(selectedPrograms) : null,
      units: selectedunits?.size ? Array.from(selectedunits) : null,
      tabs: selectedTabs.size > 0 ? Array.from(selectedTabs) : null,
    };

    const payload = {
      new_user_data: newUserData,
      mode: 'create_personnel_user',
    };

    try {
      const response = await axios.post(
        process.env.REACT_APP_API_BASE_URL + 'personnel/',
        payload,
        {
          headers: {
            Authorization: 'Token ' + user_token,
          },
        },
      );

      // console.log("Submission Success:", response.data);
      toggleModal(); // close modal on success
      fetchDataTable();
      setSelectedUser(null);
      setFirstName('');
      setLastName('');
      setEmaliform('');
      setRole('');
      setSelectedUniversities([]);
      setSelectedPrograms(new Set());
      setSelectedunits(new Set());
      setSelectedTabs(new Set());
      setValidationErrors({});
      document.getElementById('contact').value = '';
      if (response.message?.toLowerCase().includes('success')) {
        toast.success('User Added Successfully');
      } else {
        toast.error('Add User Failed');
      }
    } catch (error) {
      console.error('Submission Failed:', error);
    }
  };


  const fetchDataTable = async () => {
    try {
      const payload = {
        mode: 'get_personnel_users',
      };

      const response = await axios.post(
        process.env.REACT_APP_API_BASE_URL + 'personnel/',
        payload,
        {
          headers: {
            Authorization: 'Token ' + user_token,
          },
        },
      );

      setuserTableData(response.data || []);
    } catch (error) {
      // console.log('Error fetching unit data:', error);
    }
  };

  useEffect(() => {
    fetchDataTable();
  }, []);
  const fetchData = async () => {
    try {
      // setLoading(true);
      const response = await axios.get(
        process.env.REACT_APP_API_BASE_URL + 'personnel/',
        {
          headers: {
            Authorization: 'Token ' + user_token,
          },
        },
      );

      setuserData(response.data || []); // Ensure we set to an empty array if undefined
    } catch (error) {
      console.error('Error fetching data:', error);
    } finally {
      // setLoading(false);
    }
  };

  useEffect(() => {
    fetchData();
  }, []);

  const fetchDataUniversity = async () => {
    try {
      const payload = {
        mode: 'universities',
      };

      const response = await axios.post(
        process.env.REACT_APP_API_BASE_URL + 'personnel/',
        payload,
        {
          headers: {
            Authorization: 'Token ' + user_token,
          },
        },
      );

      setUniversities(response.data || []);
      // setTimelineTerms(unitResponse.terms || []);
    } catch (error) {
      // console.log('Error fetching unit data:', error);
    }
  };

  useEffect(() => {
    fetchDataUniversity();
  }, []);

  useEffect(() => {
    // Call fetchData only if there are selected universities
    if (selectedUniversities && selectedUniversities.length > 0) {
      fetchDataPrograms();
    }
  }, [selectedUniversities]);

  const fetchDataPrograms = async () => {
    try {
      const payload = {
        university:
          selectedUniversities.length > 0
            ? Array.from(selectedUniversities)
            : null,
        mode: 'programs',
      };

      const response = await axios.post(
        process.env.REACT_APP_API_BASE_URL + 'personnel/',
        payload,
        {
          headers: {
            Authorization: 'Token ' + user_token,
          },
        },
      );

      setPrograms(response.data || []);
    } catch (error) {
      // console.log('Error fetching unit data:', error);
    }
  };

  useEffect(() => {
    // Call fetchData only if there are selected universities or timelines
    if (selectedPrograms.size > 0) {
      fetchDataUnit();
    }
  }, [selectedPrograms]);

  const fetchDataUnit = async () => {
    try {
      const payload = {
        program:
          selectedPrograms.size > 0 ? Array.from(selectedPrograms) : null,
        mode: 'units',
      };

      const response = await axios.post(
        process.env.REACT_APP_API_BASE_URL + 'personnel/',
        payload,
        {
          headers: {
            Authorization: 'Token ' + user_token,
          },
        },
      );

      setUnits(response.data || []);
    } catch (error) {
      // console.log("Error fetching unit data:", error);
    }
  };

  //change password
  const handleChangePasswordSubmit = async () => {
    let errors = {};

    const passwordRegex =
      /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[!@#$%^&*()_\-+=<>?{}[\]~])[A-Za-z\d!@#$%^&*()_\-+=<>?{}[\]~]{8,86}$/;

    // Validate current password
    if (!currentPassword) {
      errors.currentPassword = "Current password is required";
    }

    // Validate new password
    if (!newPassword) {
      errors.newPassword = "New password is required";
    } else if (newPassword.length < 8) {
      errors.newPassword = "Password must be at least 8 characters";
    } else if (newPassword.length > 25) {
      errors.newPassword = "Password cannot exceed 25 characters";
    } else if (newPassword === currentPassword) {
      errors.newPassword = "New password must be different from current password";
    } else if (!passwordRegex.test(newPassword)) {
      errors.newPassword =
        "Password must contain uppercase, lowercase, number, and special character";
    }

    // Validate confirm password
    if (!confirmPassword) {
      errors.confirmPassword = "Confirm password is required";
    } else if (confirmPassword !== newPassword) {
      errors.confirmPassword = "Passwords do not match";
    }

    setFormErrors(errors);
    if (Object.keys(errors).length > 0) return;

    const payload = {
      old_password: currentPassword.trim(),
      new_password: newPassword.trim(),
    };

    try {
      const response = await axios.post(
        `${process.env.REACT_APP_API_BASE_URL}change_password/`,
        payload,
        {
          headers: {
            Authorization: `Token ${user_token}`,
            "Content-Type": "application/json",
          },
        }
      );
      console.log("response",response)
      if (response?.status === "success") {
        toast.success(response?.message);

        // Clear only login-related storage values
        localStorage.removeItem("i18nextLng");
        localStorage.removeItem("18N_LANGUAGE");
        localStorage.removeItem("token");
        localStorage.removeItem("usertoken");
        localStorage.removeItem("uid");
        localStorage.removeItem("username");
        localStorage.removeItem("userpremission");
        localStorage.removeItem("tabs");
        localStorage.removeItem("name");

        // toast.success("Password changed successfully. You have been logged out. Redirecting to login...");

        setTimeout(() => {
          navigate("/login");
          window.location.reload(); // ensure state resets
        }, 6000);
        toggleModalChangePassWord();
        setCurrentPassword("");
        setNewPassword("");
        setConfirmPassword("");
      } if (response?.status === "error") {
        toast.error(response?.message);
      }

    } catch (error) {
      toast.error("change password failed");
    }
  };

  const toggleModalChangePassWord = () => {
    setCurrentPassword("");
    setNewPassword("");
    setConfirmPassword("");
    setFormErrors({}); // clear validation errors
    setShowCurrent(false);
    setShowNew(false);
    setShowConfirm(false);
    setModalOpenChangePassword(!modalOpenChangePassword);
  };


  return (
    <React.Fragment>
      <div className="page-content">
        <Container fluid>
          <Breadcrumb title="OverView" breadcrumbItem="Profile" />

          <Row>
            <Col lg="12">
              {error && error ? (
                <Alert color="danger">
                  <div>{error}</div>
                </Alert>
              ) : null}
              {success ? (
                <Alert color="success">
                  <div>{success}</div>
                </Alert>
              ) : null}

              <Card>
                <CardBody>
                  <div className="d-flex">
                    <div className="ms-3">
                      <img
                        src={avatar}
                        alt=""
                        className="avatar-md rounded-circle img-thumbnail"
                      />
                    </div>
                    <div className="flex-grow-1 align-self-center">
                      <div className="text-muted">
                        <h5>{name}</h5>
                        <p className="mb-1">{email}</p>
                      </div>
                      <div>
                        <button className='btn btn-primary mt-2' onClick={toggleModalChangePassWord}>Change Password</button>
                      </div>
                    </div>
                  </div>
                  {userRole === 'admin' && (
                    <>
                      <div className="float-end">
                        <button
                          className="mt-4 btn btn-primary border-0 py-1 px-3 me-1"
                          onClick={toggleModal}
                        >
                          Add User Personnel
                        </button>
                      </div>
                      <div className="mt-2">
                        <AdminTable
                          toggleModalEdit={toggleModalEdit}
                          userDataTable={userDataTable}
                          fetchDataTable={fetchDataTable}
                          fetchData={fetchData}
                          universities={universities}
                          programs={programs}
                          units={units}
                        />
                      </div>
                    </>
                  )}
                </CardBody>
              </Card>
            </Col>
          </Row>
          <Modal centered isOpen={modalOpenChangePassword} toggle={toggleModalChangePassWord}>
            <ModalHeader toggle={toggleModalChangePassWord}>
              <h5 className="semibold">Change Password</h5>
            </ModalHeader>

            <Container className="mt-3 mb-3 p-3">
              <FormGroup>
                <Label>Email</Label>
                <Input type="email" value={email} readOnly />
              </FormGroup>

              {/* Current Password */}
              {/* <FormGroup className="position-relative">
                <Label>Current Password <span className="mandatory">*</span></Label>
                <Input
                  type={showCurrent ? "text" : "password"}
                  value={currentPassword}
                  onChange={(e) => setCurrentPassword(e.target.value)}
                  invalid={!!formErrors.currentPassword}
                />
                <span className="password-toggle" onClick={() => setShowCurrent(!showCurrent)}>
                  {showCurrent ? <FaEyeSlash /> : <FaEye />}
                </span>
                {formErrors.currentPassword && <div className="invalid-feedback">{formErrors.currentPassword}</div>}
              </FormGroup> */}
              <FormGroup className="position-relative">
                <Label>
                  Current Password <span className="mandatory">*</span>
                </Label>

                <Input
                  type={showCurrent ? "text" : "password"}
                  value={currentPassword}
                  onChange={((e) => {
                    setCurrentPassword(e.target.value);
                    setFormErrors((prev) => ({ ...prev, currentPassword: "" }))
                  })}
                  invalid={!!formErrors.currentPassword}
                  autoComplete="new-password"  // ⛔ browser autofill disable
                  formNoValidate
                  className="input-with-icon"            // ⛔ browser form autofill disable
                />

                <span
                  className="password-toggle pointer"
                  onClick={() => setShowCurrent(!showCurrent)}

                >
                  {showCurrent ? <FaEyeSlash /> : <FaEye />}
                </span>

                {formErrors.currentPassword && (
                  <div className="invalid-feedback">{formErrors.currentPassword}</div>
                )}
              </FormGroup>


              {/* New Password */}
              <FormGroup className="position-relative">
                <Label>New Password <span className="mandatory">*</span></Label>
                <Input
                  className="className="
                  type={showNew ? "text" : "password"}
                  value={newPassword}
                  onChange={(e) => {
                    setNewPassword(e.target.value);
                    setFormErrors((prev) => ({ ...prev, newPassword: "" }));
                  }}
                  invalid={!!formErrors.newPassword}
                />
                <span className="password-toggle pointer" onClick={() => setShowNew(!showNew)}>
                  {showNew ? <FaEyeSlash /> : <FaEye />}
                </span>
                {formErrors.newPassword && <div className="invalid-feedback ">{formErrors.newPassword}</div>}
              </FormGroup>

              {/* Confirm Password */}
              <FormGroup className="position-relative">
                <Label>Confirm Password <span className="mandatory">*</span></Label>
                <Input
                  className="input-with-icon"
                  type={showConfirm ? "text" : "password"}
                  value={confirmPassword}
                  onChange={(e) => {
                    setConfirmPassword(e.target.value);
                    setFormErrors((prev) => ({ ...prev, confirmPassword: "" }));
                  }}
                  invalid={!!formErrors.confirmPassword}
                />
                <span className="password-toggle pointer" onClick={() => setShowConfirm(!showConfirm)}>
                  {showConfirm ? <FaEyeSlash /> : <FaEye />}
                </span>
                {formErrors.confirmPassword && <div className="invalid-feedback">{formErrors.confirmPassword}</div>}
              </FormGroup>
            </Container>

            <ModalFooter className="border-0">
              <Button color="secondary" onClick={toggleModalChangePassWord}>
                Cancel
              </Button>
              <Button color="primary" onClick={handleChangePasswordSubmit}>
                Submit
              </Button>
            </ModalFooter>
          </Modal>

          <Modal
            isOpen={modalOpen}
            toggle={toggleModal}
            style={{ width: '80%' }}
          >
            <ModalHeader toggle={toggleModal}>Add User Personnel</ModalHeader>
            <ModalBody className="modal-body">
              <Form>
                <FormGroup>
                  <Label for="username">
                    Username
                    <span className="mandatory">*</span>
                  </Label>
                  <Select
                    id="username"
                    options={userData.map((user) => ({
                      value: user.id,
                      label: user.username,
                    }))}
                    placeholder="Select Username"
                    isSearchable
                    onChange={(selected) => {
                      const selectedUserObj = userData.find(
                        (user) => user.id === selected.value,
                      );
                      setSelectedUser(selectedUserObj || null);
                      setFirstName(selectedUserObj?.first_name || '');
                      setLastName(selectedUserObj?.last_name || '');
                      setEmaliform(selectedUserObj?.username || '');
                    }}
                  />
                  {validationErrors.username && (
                    <div className="invalid-feedback d-block">
                      {validationErrors.username}
                    </div>
                  )}
                </FormGroup>

                <FormGroup>
                  <Label for="firstName">First Name</Label>
                  <Input
                    type="text"
                    id="firstName"
                    placeholder="Enter first name"
                    value={firstName}
                    onChange={(e) => setFirstName(e.target.value)}
                  />
                </FormGroup>

                <FormGroup>
                  <Label for="lastName">Last Name</Label>
                  <Input
                    type="text"
                    id="lastName"
                    placeholder="Enter last name"
                    value={lastName}
                    onChange={(e) => setLastName(e.target.value)}
                  />
                </FormGroup>

                <FormGroup>
                  <Label for="email">
                    Email
                    <span className="mandatory">*</span>
                  </Label>
                  <Input
                    type="text"
                    id="email"
                    placeholder="Enter email"
                    value={emailform}
                    readOnly
                  />
                  {validationErrors.username && (
                    <div className="invalid-feedback d-block">
                      {validationErrors.username}
                    </div>
                  )}
                </FormGroup>

                <FormGroup>
                  <Label for="contact">Contact</Label>
                  <Input
                    type="text"
                    id="contact"
                    placeholder="Enter contact info"
                  ></Input>
                </FormGroup>

                <FormGroup>
                  <Label for="role">Role</Label>
                  <span className="mandatory">*</span>

                  <Input
                    type="select"
                    id="role"
                    value={role}
                    // invalid={!!validationErrors.role}
                    onChange={(e) => setRole(e.target.value)}
                  >
                    <option value="selectrole">Select Role</option>
                    <option value="Admin">Admin</option>
                    <option value="User">User</option>
                  </Input>
                  {validationErrors.role && (
                    <div className="invalid-feedback d-block">
                      {validationErrors.role}
                    </div>
                  )}
                </FormGroup>

                {role !== 'Admin' && (
                  <>
                    <FormGroup>
                      <Label for="university">University</Label>
                      <Select
                        id="university"
                        isMulti
                        closeMenuOnSelect={false}
                        options={universityOptions}
                        className="basic-multi-select"
                        classNamePrefix="select"
                        placeholder="Select University"
                        onChange={(selected) => {
                          const selectedValues = selected.map(
                            (item) => item.value,
                          );
                          setSelectedUniversities(selectedValues);
                        }}
                      />
                    </FormGroup>

                    <FormGroup>
                      <Label for="Program">Program</Label>
                      {/* <Select
                        id="Program"
                        isMulti
                        closeMenuOnSelect={false}
                        options={ProgramOptions}
                        className="basic-multi-select"
                        classNamePrefix="select"
                        placeholder="Select Program"
                        value={ProgramOptions.filter(opt => selectedPrograms.has(opt.value))} // This line is fine
                        onChange={(selected) => {
                          const selectedValues = new Set(selected.map(item => item.value));
                          setSelectedPrograms(selectedValues);
                        }}
                        noOptionsMessage={() =>
                          selectedUniversities.size === 0
                          ?"Please select a University"
                          :"Please select a University"
                        }
                      /> */}
                      <Select
                        isMulti
                        name="programs"
                        options={programOptions}
                        value={programOptions.filter((opt) =>
                          selectedPrograms.has(opt.value),
                        )}
                        onChange={(selected) => {
                          const values = selected?.map((s) => s.value) || [];

                          if (values.includes('all')) {
                            if (selectedPrograms.size === programs.length) {
                              setSelectedPrograms(new Set()); // deselect all
                            } else {
                              setSelectedPrograms(
                                new Set(programs.map((p) => p.id)),
                              ); // select all
                            }
                          } else {
                            setSelectedPrograms(new Set(values));
                          }
                        }}
                        noOptionsMessage={() =>
                          selectedUniversities.size === 0
                            ? 'Please select a University'
                            : programs.length === 0
                              ? 'No Programs Available'
                              : 'No Options'
                        }
                      />
                    </FormGroup>
                    <FormGroup>
                      <Label for="units">Units</Label>
                      {/* <Select
                        id="units"
                        isMulti
                        closeMenuOnSelect={false}
                        options={unitsOptions}
                        className="basic-multi-select"
                        classNamePrefix="select"
                        placeholder="Select Units"
                        value={
                          unitsOptions.length === 0
                            ? []
                            : unitsOptions.filter(opt => selectedunits.has(opt.value))
                        }
                        onChange={(selected) => {
                          const selectedValues = new Set(selected.map(item => item.value));
                          setSelectedunits(selectedValues);
                        }}
                        noOptionsMessage={() =>
                          selectedPrograms.size === 0 ? "Please Select a Program" : "No Units Available"
                        }
                      /> */}
                      <Select
                        isMulti
                        name="units"
                        options={unitOptions}
                        value={unitOptions.filter((opt) =>
                          selectedunits.has(opt.value),
                        )}
                        onChange={(selected) => {
                          const values = selected?.map((s) => s.value) || [];

                          if (values.includes('all')) {
                            if (selectedunits.size === units.length) {
                              setSelectedunits(new Set()); // deselect all
                            } else {
                              setSelectedunits(new Set(units.map((u) => u.id))); // select all
                            }
                          } else {
                            setSelectedunits(new Set(values));
                          }
                        }}
                        noOptionsMessage={() =>
                          selectedUniversities.size === 0
                            ? 'Please select a University'
                            : programs.length === 0
                              ? 'No Programs Available'
                              : 'No Options'
                        }
                      />
                    </FormGroup>

                    <FormGroup>
                      <Label for="tabs">Tabs</Label>
                      <Select
                        id="tabs"
                        isMulti
                        closeMenuOnSelect={false}
                        options={[
                          { value: 1, label: 'Overview' },
                          { value: 2, label: 'Unit Overview' },
                          { value: 3, label: 'Unit Details' },
                          { value: 4, label: 'Staff Overview' },
                          { value: 5, label: 'Staff Details' },
                        ]}
                        className="basic-multi-select"
                        classNamePrefix="select"
                        placeholder="Select Tabs"
                        value={tabOptions.filter((opt) =>
                          selectedTabs.has(opt.value),
                        )}
                        onChange={(selected) => {
                          const selectedValues = new Set(
                            selected.map((item) => item.value),
                          );
                          setSelectedTabs(selectedValues);
                        }}
                      />
                    </FormGroup>
                  </>
                )}
              </Form>
            </ModalBody>
            <ModalFooter>
              <Button
                className="float-end mb-2"
                color="primary"
                type="submit"
                onClick={handleSubmit}
              >
                Submit
              </Button>
            </ModalFooter>
          </Modal>
        </Container>
        <ToastContainer
          position="top-right"
          autoClose={3000}
          hideProgressBar={false}
          newestOnTop={false}
          closeOnClick
          rtl={false}
          pauseOnFocusLoss
          draggable
          pauseOnHover
        />
      </div>
    </React.Fragment>
  );
};

export default withRouter(UserProfile);
